module.exports = __webpack_public_path__ + "img/product.a329b06a.png";